































import { Vue, Component, Prop } from 'vue-property-decorator';

import SideBarData from '@/constants/sideBar';
import Logo from '@/components/common/Logo.vue';

@Component({
  components: { Logo }
})
export default class SideBar extends Vue {
  @Prop() public classes!: object;
  @Prop() public showHideSideBar!: any;

  public sideBarData: object[] = SideBarData;
}
